<template>
  <TextBlob headingSize="s">
    <template #heading> Reviewers </template>
    <template #text>
      <ReviewerCreationForm @pin-grab="handlePinGrab" />
      <FilterDropdown @update:filtered="handleFilter" />
      <SearchAndPagination
        :on-pin-grab="handlePinGrab"
        :on-fetch="handleFetch"
        v-model:pin-search="pinSearch"
      />
      <ReviewersTable
        class="h-full"
        :pin-search="pinSearch"
        :on-pin-grab="handlePinGrab"
      />
    </template>
  </TextBlob>
</template>

<script setup>
import TextBlob from "@/components/TextBlob.vue";
import ReviewersTable from "@/views/explorer/components/ExplorerReviewers/ReviewersTable.vue";
import ReviewerCreationForm from "@/views/explorer/components/ExplorerReviewers/sections/ReviewerCreationForm.vue";
import SearchAndPagination from "@/views/explorer/components/ExplorerReviewers/sections/SearchAndPagination.vue";
import FilterDropdown from "@/views/explorer/components/ExplorerReviewers/sections/FilterDropdown.vue";
import { ref, onMounted } from "vue";
import { useReviewers, useUser, usePinStore } from "@/stores";

const reviewersStore = useReviewers();
const userStore = useUser();
const pinSearch = ref("");

const handlePinGrab = async () => {
  const pinStore = usePinStore();
  await pinStore.initializePins();
};

const handleFilter = (isFiltered) => {
  if (isFiltered) {
    reviewersStore.fetchYesChoiceReviewers(0, 10);
  } else {
    handleFetch();
  }
};

const handleFetch = (numOfRecords = 10) => {
  const totalPages = Math.ceil(
    reviewersStore.totalReviewerCount / numOfRecords
  );

  if (userStore.currentPage > totalPages) {
    userStore.currentPage = totalPages;
  }

  if (userStore.currentPage < 1) {
    userStore.currentPage = 1;
  }

  reviewersStore.fetchReviewers(userStore.currentPage, numOfRecords, true);
};

onMounted(() => {
  handlePinGrab();
});
</script>
